exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.check-color {\n  color: #36AB6D; }\n.x-color {\n  color: crimson; }\n.hasError {\n  border: 1px solid red;\n  -webkit-box-shadow: 2px 2px 3px 3px #fac6c6;\n          box-shadow: 2px 2px 3px 3px #fac6c6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/Chetan/Downloads/angular5_admin-master/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/Chetan/Downloads/angular5_admin-master/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/Chetan/Downloads/angular5_admin-master/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/Chetan/Downloads/angular5_admin-master/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles